// TODO: Fix eslint errors.
/* eslint-disable sonarjs/no-collapsible-if */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable write-good-comments/write-good-comments */
/* eslint-disable no-plusplus */
/* eslint-disable no-shadow */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-restricted-syntax */
import queryStringHelper from 'query-string';
import removeSpacesFromText from 'removeSpacesFromText';
import latinizeString from 'latinizeString';
import params from '../../../config/params.config';

function searchParamsStringify(pageType, searchParams) {
  const paramsMapInCorrectOrder = params[pageType] || {};
  let searchPath = '';
  let queryString = '';

  function getPrefixed(paramName) {
    const prefix = paramsMapInCorrectOrder[paramName];
    if (prefix) {
      return `${prefix}-${searchParams[paramName]}/`;
    }
    return `${searchParams[paramName]}/`;
  }

  /**
   * Helper function to build a query string for multiple facets.
   *
   * @param multipleFacets
   * @returns {string}
   */
  function stringifyMultipleFacets(facets) {
    const queryObject = {};
    for (const facetType in facets) {
      if (facets.hasOwnProperty(facetType)) {
        const prefix = paramsMapInCorrectOrder[facetType];
        const params = [];
        for (const facetId in facets[facetType]) {
          if (facets[facetType].hasOwnProperty(facetId) && facets[facetType][facetId].checked) {
            params.push(facets[facetType][facetId].key);
          }
        }

        if (params) {
          queryObject[prefix] = params;
        }
      }
    }

    return queryStringHelper.stringify(queryObject, { arrayFormat: 'separator', arrayFormatSeparator: '_' });
  }

  function stringifySingleFacet(facets) {
    let path = '';
    for (const facetType in facets) {
      if (facets.hasOwnProperty(facetType)) {
        for (const facet in facets[facetType]) {
          if (facets[facetType].hasOwnProperty(facet) && facets[facetType][facet].checked) {
            path = facets[facetType][facet].key;
          }
        }
      }
    }

    return path;
  }

  function isSingleFacet(facets) {
    let facetsCount = 0;
    for (const facetType in facets) {
      if (facets.hasOwnProperty(facetType)) {
        for (const facetId in facets[facetType]) {
          if (facets[facetType].hasOwnProperty(facetId)) {
            if (facets[facetType][facetId].checked) facetsCount++;
          }
        }
      }
    }

    return facetsCount === 1;
  }

  const hasPageParam = !!searchParams.page;

  for (const paramName in paramsMapInCorrectOrder) {
    if (searchParams[paramName]) {
      if (paramName === 'query') {
        const value = paramName === 'query' ? latinizeString(removeSpacesFromText(searchParams[paramName])).toLowerCase() : searchParams[paramName];
        const stringifiedQuery = queryStringHelper.stringify({ [paramsMapInCorrectOrder[paramName]]: value });
        queryString += queryString !== '' && value ? `&${stringifiedQuery}` : stringifiedQuery;
      } else if (paramName === 'facets') {
        if (searchParams[paramName]) {
          if (isSingleFacet(searchParams[paramName])) {
            searchPath += stringifySingleFacet(searchParams[paramName]);
          } else {
            const multiFacetQueryString = stringifyMultipleFacets(searchParams[paramName]);
            queryString += queryString !== '' && multiFacetQueryString ? `&${multiFacetQueryString}` : multiFacetQueryString;
          }
        }
      } else {
        searchPath += getPrefixed(paramName);
      }
    }
  }

  if (searchPath !== '') {
    searchPath = `${searchPath}/`;
  } else {
    // searchPath = '/';
  }

  if (hasPageParam) {
    searchPath += `page-${searchParams.page}/`;
  }

  if (queryString !== '') {
    searchPath += `?${queryString}`;
  }

  return searchPath;
}
export default searchParamsStringify;
